// moment.js and date-fns use slightly different format strings to represent time :/
export const MOMENT_SHORT_TIME_FORMAT = 'h:mm a';
export const DATE_FNS_SHORT_TIME_FORMAT = 'h:mm aaa';